@let isLoading = isLoading$ | async;
@let integrationsCards = integrationsCards$ | async;

@if (isLoading === false) {
  <div class="integrations">
    <div class="page-header">
      <div class="page-header-top">
        @if (isNewIntegrationLayoutEnabled()) {
          <div class="page-title">Integrations</div>
        } @else {
          <div></div>
        }
        <app-button
          [isEnabled]="(integrationsCards?.length ?? 0) < maxIntegrations && permissionsService.isAdmin()"
          buttonIconPath="assets/images/common/plus.svg"
          tooltipPosition="left"
          [disabledTooltipText]="disabledAddIntegrationButtonReason"
          (buttonClicked)="addIntegration()"
          buttonTextLabelPath="integrationsPage.addButton"
        ></app-button>
      </div>
      @if (isNewIntegrationLayoutEnabled()) {
        <div class="page-subtitle">
          Integrations are data sources that allow Zenity to ingest and analyze information from your applications.
        </div>
      }
      @if (userService.loggedInUser['org_id'] === 'org_5gmD9cRGrozzVaxH') {
        <app-anchor-link
          navigation="https://go.microsoft.com/fwlink/?LinkId=521839"
          class="microsoft-privacy-statement"
        >
          Microsoft Privacy Statement
        </app-anchor-link>
      }
    </div>
    <div class="cards-actions">
      @if (isNewIntegrationLayoutEnabled()) {
        <span class="integrations-count"
          >{{ integrationsCards?.length ?? 0 }} integration{{ (integrationsCards?.length ?? 0) !== 1 ? 's' : '' }}</span
        >
      }
    </div>
    @if ((integrationsCards?.length ?? 0) > 0) {
      <div class="integrations-cards" [class.legacy-layout]="!isNewIntegrationLayoutEnabled()">
        @for (card of integrationsCards; track card.cardId) {
          @if (isNewIntegrationLayoutEnabled()) {
            <app-data-card [card]="card" (cardOnClick)="actionOnClick($event)"></app-data-card>
          } @else {
            <app-info-card [card]="card" (cardOnClick)="actionOnClick($event)"></app-info-card>
          }
        }
      </div>
    } @else {
      <app-no-data></app-no-data>
    }
  </div>
} @else {
  <div class="integrations-spinner">
    <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
  </div>
}
